module.exports = __webpack_public_path__ + "static/media/lyk.120b3980.png";